<!-- src/components/auth/PermissionGate.vue -->
<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useAuthz } from '@/composables/useAuthz'

const props = withDefaults(
  defineProps<{
    required?: string | string[]
    mode?: 'any' | 'all' // any = possui alguma; all = possui todas
    needsAdmin?: boolean // se true, só owner passa (pela regra do composable)
    autoLoad?: boolean // garante que store/empresa estejam carregados
  }>(),
  {
    mode: 'any',
    needsAdmin: false,
    autoLoad: true,
    required: () => [],
  }
)

const { loading, error, ensureLoaded, hasPermissions } = useAuthz()

onMounted(async () => {
  if (props.autoLoad) await ensureLoaded()
})

const allowed = computed(
  () =>
    !loading.value &&
    !error.value &&
    hasPermissions(props.required, props.mode, props.needsAdmin)
)
</script>

<template>
  <!-- carregando -->
  <slot v-if="loading" name="loading"></slot>

  <!-- erro de carregamento (opcionalmente tratar como não-autorizado) -->
  <slot v-else-if="error" :error="error" name="error">
    <div class="pa-6">
      <h3 class="text-subtitle-1 mb-2">
        Não foi possível validar suas permissões
      </h3>
      <div class="text-body-2">Tente recarregar a página.</div>
    </div>
  </slot>

  <!-- autorizado -->
  <slot v-else-if="allowed"></slot>

  <!-- fallback não autorizado -->
  <slot v-else name="fallback">
    <div class="pa-8 text-center">
      <h2 class="text-h6 mb-2">Acesso não autorizado</h2>
      <p class="text-body-2">
        Você não possui permissão para visualizar este conteúdo.
      </p>
    </div>
  </slot>
</template>
